// Мини-задание в ответе «Спроси Turkido» (followUp из lib/deepseek.ts).
// Карточка подписывает его «Попробуйте:», а модель нередко сама начинает с
// «Попробуй…» — выходило «Попробуйте: Попробуй сказать…» (QA 2026-09-24).
// Свой призыв у задания есть — подпись не добавляем.
export function followUpParts(text: string): { label: string | null; text: string } {
  const t = text.trim()
  if (/^(попробуй(те)?|скажи(те)?|составь(те)?|переведи(те)?|спроси(те)?|ответь(те)?|напиши(те)?|придумай(те)?|повтори(те)?)(?![а-яё])/i.test(t)) {
    return { label: null, text: t }
  }
  return { label: 'Попробуйте:', text: t }
}
